var module = angular.module('octopusApp.shared');

module.directive('alerts', function() {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      list: '='
    },
    templateUrl: 'areas/shared/views/alerts.html',
    link: function (scope, element, attrs) {
    },
    controller: function($scope, octopusRepository) {

    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/alerts.js
// module id = 3913067666502721
// module chunks = 1